import { LotMarche } from './LotMarche';
import { TypeResultatAttribution } from './TypeResultatAttribution';

export class Attribution {

  public resultat: TypeResultatAttribution;
  public lotMarche: LotMarche[];

  constructor() {
    this.resultat = new TypeResultatAttribution();
    this.lotMarche = [];
  }
}
